import React from 'react';
import Header from '../components/resuableComponents/Header';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import banner from '../assets/banner.png';
import ShoppingCard from '../components/resuableComponents/ShoppingCard';
import Footer from '../components/resuableComponents/Footer';

const LandingPage = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('md'));
	return (
		<>
			{matches ? (
				<>
					<Header />
					<div className='homeBanner'>
						<img className='homeBannerimg' src={banner} />
					</div>
					<div
						style={{
							display: 'flex',
							padding: 6,
							overflowX: 'auto',
							gap: 10,
							whiteSpace: 'nowrap',
							// width: '100%', // Ensure it takes up only available space
							scrollbarWidth: 'none', // Hide scrollbar in Firefox
							msOverflowStyle: 'none', // Hide scrollbar in IE/Edge
							top: '-30px',
							position: 'relative',
						}}>
						<div style={{ display: 'flex', gap: 10 }}>
							<ShoppingCard />
							<ShoppingCard />
							<ShoppingCard />
							<ShoppingCard />
						</div>
					</div>
					<Footer />
				</>
			) : (
				''
			)}
		</>
	);
};

export default LandingPage;
